module.exports = __webpack_public_path__ + "static/media/temperature-icon.9b5d5dfc.svg";